import type { AxiosInstance } from 'axios';
import Session from 'supertokens-auth-react/recipe/session';

export const Auth = {
  addAuthInterceptors(axiosInstance: AxiosInstance): void {
    axiosInstance.interceptors.request.use(async (config) => {
      try {
        config.headers['st-auth-mode'] = 'header';

        if (await Session.doesSessionExist()) {
          const accessToken = await Session.getAccessToken();
          if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
          }
        }
      } catch (error) {
        console.error('[AUTH] Failed to get access token:', error);
      }

      return config;
    });
  },
};

export default Auth;
